import { UseFormReturn } from 'react-hook-form'

import { DeliveryType } from '@enechain/eposition-proto/types/v1/deal_pb'

import { useOrderSimulationContext } from '../OrderSimulationContext'
import { OrderSimulationSchema } from '../schemas'
import { convertPhysicalContractDeliveryTypeToDeliveryType } from '../utils/deliveryTypeConverter'

type Props = {
  formMethods: UseFormReturn<OrderSimulationSchema>
  index: number
}

type Result = {
  handleChangePhysicalFuture: (isPhysicalFuture: boolean, index: number) => void
}

const DEFAULT_PHYSICAL_PHYSICAL_DELIVERY_TYPE = DeliveryType.BG

export function useSyncOutline({ formMethods, index }: Props): Result {
  const { deliveryType } = useOrderSimulationContext()
  function handleChangePhysicalFuture(isPhysicalFuture: boolean): void {
    if (isPhysicalFuture) {
      formMethods.setValue(
        `orderPattern.${index}.selfDeliveryType`,
        convertPhysicalContractDeliveryTypeToDeliveryType(deliveryType),
      )
      formMethods.setValue(
        `orderPattern.${index}.eClearDeliveryType`,
        DeliveryType.EEX,
      )
      // Reset floatingIndexCode when switching to physical future
      formMethods.setValue(
        `orderPattern.${index}.baseSummaryOrder.floatingIndexCode`,
        null,
      )
      const currentExchangeOrder = formMethods.getValues(
        `orderPattern.${index}.exchangeSummaryOrder`,
      )
      if (currentExchangeOrder !== undefined) {
        formMethods.setValue(
          `orderPattern.${index}.exchangeSummaryOrder.floatingIndexCode`,
          null,
        )
      }
    } else {
      formMethods.setValue(
        `orderPattern.${index}.selfDeliveryType`,
        DEFAULT_PHYSICAL_PHYSICAL_DELIVERY_TYPE,
      )
      formMethods.setValue(
        `orderPattern.${index}.eClearDeliveryType`,
        DeliveryType.UNSPECIFIED,
      )
    }
    formMethods.setValue(`orderPattern.${index}.baseTransactions`, [])
    formMethods.setValue(`orderPattern.${index}.exchangeTransactions`, [])
  }

  return {
    handleChangePhysicalFuture,
  }
}
